"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const components_1 = require("components");
function DatePicker({ input, meta, labelText = '', placeholder = '', minDate = undefined, maxDate = undefined, ...rest }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "date-picker-container", children: [labelText ? ((0, jsx_runtime_1.jsx)(components_1.Label, { htmlFor: input.name, size: "medium", children: labelText })) : null, (0, jsx_runtime_1.jsx)(react_datepicker_1.default, { minDate: minDate, maxDate: maxDate, placeholderText: placeholder, selected: input.value ? (0, date_fns_1.parse)(input.value, 'MM/dd/yyyy', new Date()) : null, onChange: (date) => {
                    if (date) {
                        input.onChange((0, date_fns_1.format)(new Date(date), 'MM/dd/yyyy'));
                    }
                    else {
                        input.onChange(null);
                    }
                }, name: input.name, customInput: (0, jsx_runtime_1.jsx)("input", { className: meta.error && meta.touched ? 'invalid' : '', "data-testid": `input-${input.name}`, ...input, ...rest }), onBlur: input.onBlur, onFocus: (e) => {
                    //Prevent the user from typing in the input field
                    if (e.target instanceof HTMLInputElement) {
                        e.target.readOnly = true;
                    }
                    input.onFocus();
                } }), meta.error && meta.touched ? ((0, jsx_runtime_1.jsx)(components_1.Span, { className: "error", variant: "body-medium", children: meta.error })) : null] }));
}
exports.default = DatePicker;
